module.exports = __webpack_public_path__ + "mlogo.png?6bb1eadc7bb2ea5f694b833139cfb8ba";


//////////////////
// WEBPACK FOOTER
// ./static/assets/mlogo.png
// module id = 541
// module chunks = 0